import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SnackbarService } from '../../../../_service/message-service';
import { CancelReservationRequest } from 'src/app/modules/ocpp/models/CancelReservationRequest';
import { ChangeAvailabilityRequest } from 'src/app/modules/ocpp/models/ChangeAvailabilityRequest';
import { ChangeConfigurationRequest } from 'src/app/modules/ocpp/models/ChangeConfigurationRequest';
import { ClearCacheRequest } from 'src/app/modules/ocpp/models/ClearCacheRequest';
import { ClearChargingProfileRequest } from 'src/app/modules/ocpp/models/ClearChargingProfileRequest';
import { DataTransferRequest } from 'src/app/modules/ocpp/models/DataTransferRequest';
import { GetCompositeScheduleRequest } from 'src/app/modules/ocpp/models/GetCompositeScheduleRequest';
import { GetConfigurationRequest } from 'src/app/modules/ocpp/models/GetConfigurationRequest';
import { GetDiagnosticsRequest } from 'src/app/modules/ocpp/models/GetDiagnosticsRequest';
import { GetLocalListVersionRequest } from 'src/app/modules/ocpp/models/GetLocalListVersionRequest';
import { RemoteStartTransactionRequest } from 'src/app/modules/ocpp/models/RemoteStartTransactionRequest';
import { RemoteStopTransactionRequest } from 'src/app/modules/ocpp/models/RemoteStopTransactionRequest';
import { ReserveNowRequest } from 'src/app/modules/ocpp/models/ReserveNowRequest';
import { ResetRequest } from 'src/app/modules/ocpp/models/ResetRequest';
import { SendLocalListRequest } from 'src/app/modules/ocpp/models/SendLocalListRequest';
import { SetChargingProfileRequest } from 'src/app/modules/ocpp/models/SetChargingProfileRequest';
import { TriggerMessageRequest } from 'src/app/modules/ocpp/models/TriggerMessageRequest';
import { UnlockConnectorRequest } from 'src/app/modules/ocpp/models/UnlockConnectorRequest';
import { UpdateFirmwareRequest } from 'src/app/modules/ocpp/models/UpdateFirmwareRequest';
import { CoreService } from 'src/app/modules/ocpp/service/core.service';
import { LocalAuthorizationListManagementService } from 'src/app/modules/ocpp/service/local-authorization-list-management.service';
import { StationService } from 'src/app/_services/station.service';
import { Request } from 'src/app/modules/ocpp/models/Request';
import { ReservationService } from 'src/app/modules/ocpp/service/reservation.service';
import { RemoteTriggerService } from 'src/app/modules/ocpp/service/remote-trigger.service';
import { SmartChargingService } from 'src/app/modules/ocpp/service/smart-charging.service';
import { validateChargingProfileConnector } from '../../../smart-charging/create-charging-profile/charging-profile.validators';
import { FirmwareManagementService } from 'src/app/modules/ocpp/service/firmware-management.service';
import { RfidServiceService } from 'src/app/_service/rfid-service.service';
import { ChargingProfileService } from 'src/app/components/smart-charging/create-charging-profile/charging-profile.service';
import { TransactionsService } from 'src/app/components/transactions/transactions.service';
import { ResetType } from 'src/app/modules/ocpp/enums/reset.type.enum';
import { AvailabilityType } from 'src/app/modules/ocpp/enums/availability.type.enum';
import { MessageTriggerType } from 'src/app/modules/ocpp/enums/message.trigger.enum';
import { ConfigurationKeys } from 'src/app/modules/ocpp/enums/config.keys.enum';
import { UpdateType } from 'src/app/modules/ocpp/enums/update.type.enum';
import { ChargingProfilePurposeType } from 'src/app/modules/ocpp/enums/charging.profile.purpose.enum';
import { ChargingRateUnitType } from 'src/app/modules/ocpp/enums/charging.rate.unit.type.enum';
import { ChargingList, FirmwareList, LocalList, ReservationList, TilesDetailsList, TilesList, TriggerList } from './manage-config';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { Role } from 'src/app/util/enums/role.enum';
import { ChargeBoxService } from 'src/app/_services/chargebox/chargebox.service';


declare var $: any;


@Component({
  selector: 'telio-device-manage',
  templateUrl: './device-manage.component.html',
  styleUrls: ['./device-manage.component.scss']
})
export class DeviceManageComponent implements OnInit {
  basicAuthEnabled = false;
  stationID: any;
  changeAvailabilityRequest: ChangeAvailabilityRequest;
  changeConfigurationRequest: ChangeConfigurationRequest;
  resetRequest: ResetRequest;
  clearCacheRequest: ClearCacheRequest;
  reserveNowRequest: ReserveNowRequest;
  cancelReservationRequest: CancelReservationRequest;
  unlockConnectorRequest: UnlockConnectorRequest;
  remoteStartTransactionRequest: RemoteStartTransactionRequest;
  remoteStopTransactionRequest: RemoteStopTransactionRequest;
  getConfigurationRequest: GetConfigurationRequest;
  dataTransferRequest: DataTransferRequest;
  getCompositeScheduleRequest: GetCompositeScheduleRequest;
  setChargingProfileRequest: SetChargingProfileRequest;
  clearChargingProfileRequest: ClearChargingProfileRequest;
  triggerMessageRequest: TriggerMessageRequest;
  getLocalListVersionRequest: GetLocalListVersionRequest;
  sendLocalListRequest: SendLocalListRequest;
  updateFirmwareRequest: UpdateFirmwareRequest;
  getDiagnosticsRequest: GetDiagnosticsRequest;
  connectors: any = [];
  @Input() stationId: any;
  @Input() stationdetail: any;
  private ocppTags: any = [];
  private loggedInUser: any = {};
  chargingProfiles: any = [];
  private activeTransactions: any = [];
  private activeReservations: any = [];
  selectedResetType: ResetType = ResetType.SOFT;
  resetTypeKeys = [];
  resetType = ResetType;
  selectedAvailabilityType: AvailabilityType = AvailabilityType.OPERATIVE;
  availabilityTypeKeys = [];
  availabilityType = AvailabilityType;
  selectedMessageTriggerType: MessageTriggerType = MessageTriggerType.BootNotification;
  messageTriggerTypeKeys = [];
  messageTriggerType = MessageTriggerType;
  private modalFormGroup: Map<string, UntypedFormGroup> = new Map();
  configurationKeyTypeKeys = [];
  configurationKeyType = ConfigurationKeys;
  selectedUpdateType: UpdateType = UpdateType.DIFFERENTIAL;
  updateTypeKeys = [];
  updateType = UpdateType;
  selectedChargingProfilePurposeType: ChargingProfilePurposeType = ChargingProfilePurposeType.TX_PROFILE;
  chargingProfilePurposeTypeKeys = [];
  chargingProfilePurposeType = ChargingProfilePurposeType;
  selectedChargingRateUnitType: ChargingRateUnitType = ChargingRateUnitType.A;
  chargingRateUnitTypeKeys = [];
  chargingRateUnitType = ChargingRateUnitType;
  tilesList = TilesList;
  selectedIndex = 0;
  tilesDetailsList = TilesDetailsList;
  selectedDetailsIndex: number;
  firmwareList = FirmwareList;
  firmwareIndex: number;
  localList = LocalList;
  localListIndex: number;
  reservationList = ReservationList;
  reservationListIndex: number;
  triggerList = TriggerList;
  triggerListIndex: number;
  chargingList = ChargingList;
  chargingListIndex: number;

  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  sortColumn = '';
  sortDirection = 'asc';
  @Input() routeID = null;
  
  constructor(
    private stationService: StationService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private coreService: CoreService,
    private toasterService: SnackbarService,
    private localAuthorizationListManagementService: LocalAuthorizationListManagementService,
    private reservationService: ReservationService,
    private remoteTriggerService: RemoteTriggerService,
    private smartChargingService: SmartChargingService,
    private firmwareManagementService: FirmwareManagementService,
    private userInfoService: UserInfoService,
    private rfidService: RfidServiceService,
    private chargingProfileService: ChargingProfileService,
    private transactionsService: TransactionsService,
    private chargeBoxService:ChargeBoxService
  ) {
  
  }

  /* Forms Start */
  // changeConfigurationForm = this.formBuilder.group({
  //   confKey: ['', []],
  //   value: ['', []],
  //   customConfKey: [''],
  //   customValue:['']
  // });

  changeConfigurationForm = this.formBuilder.group({
    confKey: [''],
    value: [''],
    customConfKey: [''],
    customValue: ['']
  }, { validators: this.atLeastOneSetValidator });

  atLeastOneSetValidator(form: FormGroup) {
    const confKey = form.get('confKey').value;
    const value = form.get('value').value;
    const customConfKey = form.get('customConfKey').value;
    const customValue = form.get('customValue').value;
    
    if ((confKey && value) || (customConfKey && customValue)) {
      return null; 
    } else {
      return { atLeastOneSetRequired: true };
    }
  }

  remoteStartTransactionForm = this.formBuilder.group({
    idTag: ['', [Validators.required]],
    chargingProfileId: [''],
    connectorId: ['', [Validators.required]]
  });
  changeAvailabilityForm = this.formBuilder.group({
    connectorId: ['', [Validators.required]],
    availType: ['', [Validators.required]]
  });
  unlockConnectorForm = this.formBuilder.group({
    connectorId: ['', [Validators.required]]
  });
  resetForm = this.formBuilder.group({
    resetType: ['', [Validators.required]]
  });
  sendLocalListForm = this.formBuilder.group({
    listVersion: ['', [Validators.required]],
    updateType: ['', [Validators.required]],
    deleteList: [''],
    addUpdateList: [''],
    sendEmptyListWhenFull: ['']
  });
  reserveNowForm = this.formBuilder.group({
    connectorId: ['', [Validators.required]],
    expiry: ['', [Validators.required]],
    idTag: ['', [Validators.required]],
  });
  triggerMessageForm = this.formBuilder.group({
    connectorId: ['', [Validators.required]],
    triggerMessage: ['', [Validators.required]]
  });
  setChargingProfileForm = this.formBuilder.group({
    connectorId: ['', [Validators.required]],
    chargingProfileId: ['', [Validators.required, validateChargingProfileConnector.bind(this)]]
  });
  clearChargingProfileForm = this.formBuilder.group({
    connectorId: [''],
    chargingProfilePurpose: [''],
    stackLevel: [''],
    chargingProfileId: [''],
    filterType: ['', [Validators.required]]
  });
  getCompositeScheduleForm = this.formBuilder.group({
    connectorId: ['', [Validators.required]],
    duration: ['', [Validators.required]],
    chargingRateUnit: ['']
  });
  cancelReservationForm = this.formBuilder.group({
    reservationId: ['', [Validators.required]]
  });
  updateFirmwareForm = this.formBuilder.group({
    // location: ['', [Validators.required, Validators.pattern('^(ftps:\\/\\/|ftp:\\/\\/|http:\\/\\/|https:\\/\\/)[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$')]],
    location: ['', [Validators.required, Validators.pattern('^(http:\\/\\/|https:\\/\\/|ftp:\\/\\/|ftps:\\/\\/).*$')]],
    retrieve: ['', [Validators.required]],
    retries: [''],
    retryInterval: ['']
  });
  getDiagnosticsForm = this.formBuilder.group({
    location: ['', [Validators.required]],
    retries: [''],
    start: [''],
    stop: [''],
    retryInterval: ['']
  });
  dataTransferForm = this.formBuilder.group({
    vendorId: ['', [Validators.required]],
    messageId: [''],
    data: ['']
  });
  getConfigurationForm = this.formBuilder.group({
    confKeyList: [''],
    commaSeparatedCustomConfKeys: [''],
    getConfigurationValue:['']
  });
  remoteStopTransactionForm = this.formBuilder.group({
    transactionId: ['', [Validators.required]],
  });

  ngOnInit() {
    this.resetTypeKeys = Object.keys(this.resetType);
    this.availabilityTypeKeys = Object.keys(this.availabilityType);
    this.messageTriggerTypeKeys = Object.keys(this.messageTriggerType);
    // this.configurationKeyTypeKeys = Object.keys(this.configurationKeyType);
    this.getCofigurationKeyList();
    this.updateTypeKeys = Object.keys(this.updateType);
    this.chargingProfilePurposeTypeKeys = Object.keys(this.chargingProfilePurposeType);
    this.chargingRateUnitTypeKeys = Object.keys(this.chargingRateUnitType);

    this.changeAvailabilityRequest = new ChangeAvailabilityRequest([this.stationId]);
    this.changeConfigurationRequest = new ChangeConfigurationRequest([this.stationId]);
    this.getConfigurationRequest = new GetConfigurationRequest([this.stationId]);
    this.clearCacheRequest = new ClearCacheRequest([this.stationId]);
    this.resetRequest = new ResetRequest([this.stationId]);
    this.unlockConnectorRequest = new UnlockConnectorRequest([this.stationId]);
    this.remoteStartTransactionRequest = new RemoteStartTransactionRequest([this.stationId]);
    this.remoteStopTransactionRequest = new RemoteStopTransactionRequest([this.stationId]);
    this.getLocalListVersionRequest = new GetLocalListVersionRequest([this.stationId]);
    this.sendLocalListRequest = new SendLocalListRequest([this.stationId]);
    this.triggerMessageRequest = new TriggerMessageRequest([this.stationId]);
    this.setChargingProfileRequest = new SetChargingProfileRequest([this.stationId]);
    this.clearChargingProfileRequest = new ClearChargingProfileRequest([this.stationId]);
    this.getCompositeScheduleRequest = new GetCompositeScheduleRequest([this.stationId]);
    this.updateFirmwareRequest = new UpdateFirmwareRequest([this.stationId]);
    this.getDiagnosticsRequest = new GetDiagnosticsRequest([this.stationId]);
    this.reserveNowRequest = new ReserveNowRequest([this.stationId]);
    this.cancelReservationRequest = new CancelReservationRequest([this.stationId]);
    this.dataTransferRequest = new DataTransferRequest([this.stationId]);
    if (this.stationdetail && this.stationdetail.connectors && this.stationdetail.connectors.length > 0)
      this.connectors = this.stationdetail.connectors[0].connectors;
    this.fetchOCPPTags();
    this.getChargingProfiles();
    this.fetchActiveReservations();
    this.fetchActiveTransactions();
    this.populateModelFormGroups();
    this.registerModelCloseHandlers();
    this.registerCustomValidators();
  }

  registerCustomValidators = () => {
    // Trigger Validation if connectorId is changed on SetChargingProfile
    this.setChargingProfileForm.get('connectorId').valueChanges
      .subscribe(value => {
        this.setChargingProfileForm.get('chargingProfileId').updateValueAndValidity();
      });
  }


  fetchOCPPTags() {
    this.loggedInUser = this.userInfoService.userDetails;
    if (this.userInfoService.isAdminGroup()) {
      this.rfidService.getAllAssignedRfids(1,100000,'','asc','').subscribe((response: any) => {
        this.ocppTags = response && response.content ? response.content : [];
      });
    } else if (this.userInfoService.isCPOSubCPOGroup()) {
      this.rfidService.getAllAssignedRfidsByCpo(this.loggedInUser.userId,1,100000,'','asc','').subscribe((response: any) => {
        this.ocppTags = response && response.content ? response.content : [];
      });
    } else if (!this.userInfoService.isStationManagerCPOGroup()){
      this.rfidService.getAllAssignedRfidsByCpo(this.loggedInUser.userId,1,100000,'','asc','').subscribe((response: any) => {
        this.ocppTags = response && response.content ? response.content : [];
      });
    }
  }

  getChargingProfiles() {
    this.chargingProfileService.getTotalChargingProfiles(this.userInfoService.userDetails.email).subscribe((resp: any) => {
      this.chargingProfiles = resp.body.data;
    });
  }

  fetchActiveReservations() {
    this.transactionsService.getAllActiveReservations('active', this.stationId).subscribe((response: any) => {
      this.activeReservations = response ? response : [];
    });
  }

  fetchActiveTransactions() {
    this.transactionsService.getAllActiveTransactions('CHARGING', this.stationId).subscribe((response: any) => {
      this.activeTransactions = response ? response : [];
    });
  }

  populateModelFormGroups() {
    this.modalFormGroup.set('remoteStartTransaction', this.remoteStartTransactionForm);
    this.modalFormGroup.set('remoteStopTransaction', this.remoteStopTransactionForm);
    this.modalFormGroup.set('reset', this.resetForm);
    this.modalFormGroup.set('changeAvailability', this.changeAvailabilityForm);
    this.modalFormGroup.set('triggerMessage', this.triggerMessageForm);
    this.modalFormGroup.set('cancelReservation', this.cancelReservationForm);
    this.modalFormGroup.set('reserveNow', this.reserveNowForm);
    this.modalFormGroup.set('unlockConnector', this.unlockConnectorForm);
    this.modalFormGroup.set('setChargingProfile', this.setChargingProfileForm);
    this.modalFormGroup.set('changeConfiguration', this.changeConfigurationForm);

    this.modalFormGroup.set('updateFirmware', this.updateFirmwareForm);
    this.modalFormGroup.set('dataTransfer', this.dataTransferForm);
    this.modalFormGroup.set('getConfiguration', this.getConfigurationForm);
    this.modalFormGroup.set('getDiagnostics', this.getDiagnosticsForm);
    this.modalFormGroup.set('sendLocalList', this.sendLocalListForm);

    this.modalFormGroup.set('clearChargingProfile', this.clearChargingProfileForm);
    this.modalFormGroup.set('getCompositeSchedule', this.getCompositeScheduleForm);
  }

  registerModelCloseHandlers() {
    $('div.ocpp-operation-modal').on('hidden.bs.modal', e => {
      const button = e.target;
      const formGroup = this.modalFormGroup.get(button.id);
      if (formGroup) {
        this.clearForm(this.modalFormGroup.get(button.id));
      }
    });
  }

  updateSecurity() {
    this.stationService.updateSecurity(this.stationId, !this.basicAuthEnabled).subscribe(resp => {
      if (!!resp) {
        this.basicAuthEnabled = !this.basicAuthEnabled;
      }
    });
  }

  clearForm(form: UntypedFormGroup) {
    form.reset();
  }

  /**
       * @description Handler for Core : Change Availability Transaction
       * @param changeAvailabilityRequest Model Data representing user's selection
       */
  initiateTransaction(transactionRequest: Request) {
    switch (transactionRequest.constructor) {
      case ChangeAvailabilityRequest:
        this.changeAvailability(transactionRequest as ChangeAvailabilityRequest);
        break;
      case ChangeConfigurationRequest:
        this.changeConfiguration(transactionRequest as ChangeConfigurationRequest);
        break;
      case UnlockConnectorRequest:
        this.unlockConnector(transactionRequest as UnlockConnectorRequest);
        break;
      case ResetRequest:
        this.reset(transactionRequest as ResetRequest);
        break;
      case SendLocalListRequest:
        this.sendLocalList(transactionRequest as SendLocalListRequest);
        break;
      case GetLocalListVersionRequest:
        this.getLocalListVersion(transactionRequest as GetLocalListVersionRequest);
        break;
      case ReserveNowRequest:
        this.reserveNow(transactionRequest as ReserveNowRequest);
        break;
      case ClearCacheRequest:
        this.clearCache(transactionRequest as ClearCacheRequest);
        break;
      case TriggerMessageRequest:
        this.triggerMessage(transactionRequest as TriggerMessageRequest);
        break;
      case SetChargingProfileRequest:
        this.setChargingProfile(transactionRequest as SetChargingProfileRequest);
        break;
      case ClearChargingProfileRequest:
        this.clearChargingProfile(transactionRequest as ClearChargingProfileRequest);
        break;
      case GetCompositeScheduleRequest:
        this.getCompositeSchedule(transactionRequest as GetCompositeScheduleRequest);
        break;
      case CancelReservationRequest:
        this.cancelReservation(transactionRequest as CancelReservationRequest);
        break;
      case UpdateFirmwareRequest:
        this.updateFirmware(transactionRequest as UpdateFirmwareRequest);
        break;
      case GetDiagnosticsRequest:
        this.getDiagnostics(transactionRequest as GetDiagnosticsRequest);
        break;
      case DataTransferRequest:
        this.dataTransfer(transactionRequest as DataTransferRequest);
        break;
      case GetConfigurationRequest:
        this.getConfiguration(transactionRequest as GetConfigurationRequest);
        break;
      case RemoteStartTransactionRequest:
        this.remoteStartTransaction(transactionRequest as RemoteStartTransactionRequest);
        break;
      case RemoteStopTransactionRequest:
        this.remoteStopTransaction(transactionRequest as RemoteStopTransactionRequest);
        break;
      default:
        console.error(`Transaction ${transactionRequest} not supported!`);
    }
  }

  /**
       * @description Handler for Core : Change Availability Transaction
       * @param changeAvailabilityRequest Model Data representing user's selection
       */
  private changeAvailability(changeAvailabilityRequest: ChangeAvailabilityRequest) {

    if (!this.changeAvailabilityForm.valid) {
      this.changeAvailabilityForm.markAllAsTouched();
      return;
    }
    this.coreService.changeAvailability(changeAvailabilityRequest).subscribe(response => {
      $('#changeAvailability').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
      this.clearForm(this.changeAvailabilityForm);
    }, error => {
      this.toasterService.error(`Error in Executing ChangeAvailability Operation!`);
      $('#changeAvailability').modal('hide');
      console.error('changeAvailability Error: ' + error);
      this.clearForm(this.changeAvailabilityForm);
    });
  }

  /**
     * @description Handler for Core : Change Availability Transaction
     * @param changeAvailabilityRequest Model Data representing user's selection
     */
  private changeConfiguration(changeConfigurationRequest: ChangeConfigurationRequest) {
    if (!this.changeConfigurationForm.valid) {
      this.changeConfigurationForm.markAllAsTouched();
      return;
    }
    this.coreService.changeConfiguration(changeConfigurationRequest).subscribe(response => {
      $('#changeConfiguration').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
      this.clearForm(this.changeConfigurationForm);
    }, error => {
      $('#changeConfiguration').modal('hide');
      this.toasterService.error(`Error in Executing ChangeConfiguration Operation!`);
      console.error('changeConfiguration Error: ' + error);
      this.clearForm(this.changeConfigurationForm);
    });
  }

  /**
     * @description Handler for Core : Change Availability Transaction
     * @param changeAvailabilityRequest Model Data representing user's selection
     */
  private unlockConnector(unlockConnectorRequest: UnlockConnectorRequest) {
    if (!this.unlockConnectorForm.valid) {
      this.unlockConnectorForm.markAllAsTouched();
      return;
    }
    this.coreService.unlockConnector(unlockConnectorRequest).subscribe(response => {
      $('#unlockConnector').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
      this.clearForm(this.unlockConnectorForm);
    }, error => {
      $('#unlockConnector').modal('hide');
      this.toasterService.error(`Error in Executing UnlockConnector Operation!`);
      console.error('unlockConnector Error: ' + error);
      this.clearForm(this.unlockConnectorForm);
    });
  }

  /**
       * @description Handler for Core : Change Availability Transaction
       * @param changeAvailabilityRequest Model Data representing user's selection
       */
  private reset(resetRequest: ResetRequest) {
    if (!this.resetForm.valid) {
      this.resetForm.markAllAsTouched();
      return;
    }
    this.coreService.reset(resetRequest).subscribe((response: any) => {
      if (response.statusCode === 200) {
        $('#reset').modal('hide');
        this.toasterService.success(response.message || 'Transaction Posted Successfully!');
      } else if(response.statusCode === 409){
        $('#reset').modal('hide');
        this.toasterService.warning(response.message || 'Charging is currently in progress on one of the connectors. Please try again later.');
      }
      else {
        this.toasterService.warning(response.message || 'Unexpected response from the server.');
      }
      this.clearForm(this.resetForm);
    }, error => {
      $('#reset').modal('hide');
      this.toasterService.error(`Error in Executing Reset Operation!`);
      console.error('reset Error: ' + error);
      this.clearForm(this.resetForm);
    });
  }

  /**
      * @description Handler for Core : Change Availability Transaction
      * @param changeAvailabilityRequest Model Data representing user's selection
      */
  private sendLocalList(sendLocalListRequest: SendLocalListRequest) {
    if (!this.sendLocalListForm.valid) {
      this.sendLocalListForm.markAllAsTouched();
      return;
    }
    this.localAuthorizationListManagementService.sendLocalList(sendLocalListRequest).subscribe(response => {
      $('#sendLocalList').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
      this.clearForm(this.sendLocalListForm);
    }, error => {
      $('#sendLocalList').modal('hide');
      this.toasterService.error(`Error in Executing SendLocalList Operation!`);
      console.error('sendLocalList Error: ' + error);
      this.clearForm(this.sendLocalListForm);
    });
  }

  /**
       * @description Handler for Core : Change Availability Transaction
       * @param changeAvailabilityRequest Model Data representing user's selection
       */
  private getLocalListVersion(getLocalListVersionRequest: GetLocalListVersionRequest) {
    this.localAuthorizationListManagementService.getLocalListVersion(getLocalListVersionRequest).subscribe(response => {
      $('#getLocalListVersion').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
    }, error => {
      $('#getLocalListVersion').modal('hide');
      this.toasterService.error(`Error in Executing GetLocalListVersion Operation!`);
      console.error('getLocalListVersion Error: ' + error);
    });
  }

  /**
       * @description Handler for Core : Change Availability Transaction
       * @param changeAvailabilityRequest Model Data representing user's selection
       */
  private reserveNow(reserveNowRequest: ReserveNowRequest) {
    if (!this.reserveNowForm.valid) {
      this.reserveNowForm.markAllAsTouched();
      return;
    }
    this.reservationService.reserveNow(reserveNowRequest).subscribe(response => {
      $('#getCompositeSchedule').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
      this.clearForm(this.reserveNowForm);
    }, error => {
      $('#getCompositeSchedule').modal('hide');
      this.toasterService.error(`Error in Executing ReserveNow Operation!`);
      console.error('getCompositeSchedule Error: ' + error);
      this.clearForm(this.reserveNowForm);
    });
  }

  /**
       * @description Handler for Core : Change Availability Transaction
       * @param changeAvailabilityRequest Model Data representing user's selection
       */
  private clearCache(clearCacheRequest: ClearCacheRequest) {
    this.coreService.clearCache(clearCacheRequest).subscribe(response => {
      $('#clearCache').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
    }, error => {
      $('#clearCache').modal('hide');
      this.toasterService.error(`Error in Executing ClearCache Operation!`);
      console.error('clearCache Error: ' + error);
    });
  }

  /**
       * @description Handler for Core : Change Availability Transaction
       * @param changeAvailabilityRequest Model Data representing user's selection
       */
  private triggerMessage(triggerMessageRequest: TriggerMessageRequest) {
    if (!this.triggerMessageForm.valid) {
      this.triggerMessageForm.markAllAsTouched();
      return;
    }
    this.remoteTriggerService.triggerMessage(triggerMessageRequest).subscribe(response => {
      $('#triggerMessage').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
      this.clearForm(this.triggerMessageForm);
    }, error => {
      $('#triggerMessage').modal('hide');
      this.toasterService.error(`Error in Executing TriggerMessage Operation!`);
      console.error('triggerMessage Error: ' + error);
      this.clearForm(this.triggerMessageForm);
    });
  }

  /**
       * @description Handler for Smart Charging : Set Charging Profile Transaction
       * @param setChargingProfileRequest Model Data representing user's selection
       */
  private setChargingProfile(setChargingProfileRequest: SetChargingProfileRequest) {
    if (!this.setChargingProfileForm.valid) {
      this.setChargingProfileForm.markAllAsTouched();
      return;
    }
    this.smartChargingService.setChargingProfile(setChargingProfileRequest).subscribe(response => {
      $('#setChargingProfile').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
      this.clearForm(this.setChargingProfileForm);
    }, error => {
      this.toasterService.error(`Error in Executing SetChargingProfile Operation!`);
      $('#setChargingProfile').modal('hide');
      console.error('setChargingProfile Error: ' + error);
      this.clearForm(this.setChargingProfileForm);
    });
  }

  /**
  * @description Handler for Core : Change Availability Transaction
  * @param changeAvailabilityRequest Model Data representing user's selection
  */
  private clearChargingProfile(clearChargingProfileRequest: ClearChargingProfileRequest) {
    if (!this.clearChargingProfileForm.valid) {
      this.clearChargingProfileForm.markAllAsTouched();
      return;
    }
    this.smartChargingService.clearChargingProfile(clearChargingProfileRequest).subscribe(response => {
      $('#clearChargingProfile').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
      this.clearForm(this.clearChargingProfileForm);
    }, error => {
      $('#clearChargingProfile').modal('hide');
      this.toasterService.error(`Error in Executing ClearChargingProfile Operation!`);
      console.error('clearChargingProfile Error: ' + error);
      this.clearForm(this.clearChargingProfileForm);
    });
  }

  /**
  * @description Handler for Core : Change Availability Transaction
  * @param changeAvailabilityRequest Model Data representing user's selection
  */
  private getCompositeSchedule(getCompositeScheduleRequest: GetCompositeScheduleRequest) {
    if (!this.getCompositeScheduleForm.valid) {
      this.getCompositeScheduleForm.markAllAsTouched();
      return;
    }
    this.smartChargingService.getCompositeSchedule(getCompositeScheduleRequest).subscribe(response => {
      $('#getCompositeSchedule').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
      this.clearForm(this.getCompositeScheduleForm);
    }, error => {
      $('#getCompositeSchedule').modal('hide');
      this.toasterService.error(`Error in Executing GetCompositeSchedule Operation!`);
      console.error('getCompositeSchedule Error: ' + error);
      this.clearForm(this.getCompositeScheduleForm);
    });
  }

  /**
       * @description Handler for Core : Change Availability Transaction
       * @param changeAvailabilityRequest Model Data representing user's selection
       */
  private cancelReservation(cancelReservationRequest: CancelReservationRequest) {
    if (!this.cancelReservationForm.valid) {
      this.cancelReservationForm.markAllAsTouched();
      return;
    }
    this.reservationService.cancelReservation(cancelReservationRequest).subscribe(response => {
      $('#cancelReservation').modal('hide');
      if (response.statusCode === 409) {
        this.toasterService.info(response.message)
      } else {
        this.toasterService.success('Transaction Posted Successfully!');
      }
      this.clearForm(this.cancelReservationForm);
    }, error => {
      $('#cancelReservation').modal('hide');
      this.toasterService.error(`Error in Executing CancelReservation Operation!`);
      console.error('cancelReservation Error: ' + error);
      this.clearForm(this.cancelReservationForm);
    });
  }

  /**
       * @description Handler for Core : Change Availability Transaction
       * @param changeAvailabilityRequest Model Data representing user's selection
       */
  private updateFirmware(updateFirmwareRequest: UpdateFirmwareRequest) {
    if (!this.updateFirmwareForm.valid) {
      this.updateFirmwareForm.markAllAsTouched();
      return;
    }
    this.firmwareManagementService.updateFirmware(updateFirmwareRequest).subscribe(response => {
      $('#updateFirmware').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
      this.clearForm(this.updateFirmwareForm);
    }, error => {
      $('#updateFirmware').modal('hide');
      this.toasterService.error(`Error in Executing UpdateFirmware Operation!`);
      console.error('updateFirmware Error: ' + error);
      this.clearForm(this.updateFirmwareForm);
    });
  }

  /**
       * @description Handler for Core : Change Availability Transaction
       * @param changeAvailabilityRequest Model Data representing user's selection
       */
  private getDiagnostics(getDiagnosticsRequest: GetDiagnosticsRequest) {
    if (!this.getDiagnosticsForm.valid) {
      this.getDiagnosticsForm.markAllAsTouched();
      return;
    }
    this.firmwareManagementService.getDiagnostics(getDiagnosticsRequest).subscribe(response => {
      $('#getDiagnostics').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
      this.clearForm(this.getDiagnosticsForm);
    }, error => {
      $('#getDiagnostics').modal('hide');
      this.toasterService.error(`Error in Executing GetDiagnostics Operation!`);
      console.error('getDiagnostics Error: ' + error);
      this.clearForm(this.getDiagnosticsForm);
    });
  }

  /**
   * @description Handler for Core : Change Availability Transaction
   * @param changeAvailabilityRequest Model Data representing user's selection
   */
  private dataTransfer(dataTransferRequest: DataTransferRequest) {
    if (!this.dataTransferForm.valid) {
      this.dataTransferForm.markAllAsTouched();
      return;
    }
    this.coreService.dataTransfer(dataTransferRequest).subscribe(response => {
      $('#dataTransfer').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
      this.clearForm(this.dataTransferForm);
    }, error => {
      $('#dataTransfer').modal('hide');
      this.toasterService.error(`Error in Executing DataTransfer Operation!`);
      console.error('dataTransfer Error: ' + error);
      this.clearForm(this.dataTransferForm);
    });
  }

  /**
     * @description Handler for Core : Change Availability Transaction
     * @param changeAvailabilityRequest Model Data representing user's selection
     */
  private getConfiguration(getConfigurationRequest: GetConfigurationRequest) {
    if (!this.getConfigurationForm.valid) {
      this.getConfigurationForm.markAllAsTouched();
      return;
    }
    this.coreService.getConfiguration(getConfigurationRequest).subscribe(response => {
      $('#getConfiguration').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
      this.clearForm(this.getConfigurationForm);
    }, error => {
      $('#getConfiguration').modal('hide');
      this.toasterService.error(`Error in Executing GetConfiguration Operation!`);
      console.error('getConfiguration Error: ' + error);
      this.clearForm(this.getConfigurationForm);
    });
  }

  /**
       * @description Handler for Core : Change Availability Transaction
       * @param changeAvailabilityRequest Model Data representing user's selection
       */
  private remoteStartTransaction(remoteStartTransactionRequest: RemoteStartTransactionRequest) {
    if (!this.remoteStartTransactionForm.valid) {
      this.remoteStartTransactionForm.markAllAsTouched();
      return;
    }
    this.coreService.remoteStartTransaction(remoteStartTransactionRequest).subscribe(response => {
      $('#remoteStartTransaction').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
      this.clearForm(this.remoteStartTransactionForm);
    }, error => {
      $('#remoteStartTransaction').modal('hide');
      this.toasterService.error(`Error in Executing RemoteStartTransaction Operation!`);
      console.error('remoteStartTransaction Error: ' + error);
      this.clearForm(this.remoteStartTransactionForm);
    });
  }

  /**
      * @description Handler for Core : Change Availability Transaction
      * @param changeAvailabilityRequest Model Data representing user's selection
      */
  remoteStopTransaction(remoteStopTransactionRequest: RemoteStopTransactionRequest) {
    if (!this.remoteStopTransactionForm.valid) {
      this.remoteStopTransactionForm.markAllAsTouched();
      return;
    }
    this.coreService.remoteStopTransaction(remoteStopTransactionRequest).subscribe(response => {
      $('#remoteStopTransaction').modal('hide');
      this.toasterService.success('Transaction Posted Successfully!');
      this.clearForm(this.remoteStopTransactionForm);
    }, error => {
      $('#remoteStopTransaction').modal('hide');
      this.toasterService.error(`Error in Executing RemoteStopTransaction Operation!`);
      console.error('remoteStopTransaction Error: ' + error);
      this.clearForm(this.remoteStopTransactionForm);
    });
  }

  getstationlistbyid(id) {
    this.stationService.getstationlistbyid(id).subscribe(
      (data: any) => {
        Object.keys(data).map(x => {
          if (data[x] !== false) {
            (!data[x] || data[x] == '') ? data[x] = 'NA' : null;
          }
        });
        this.stationdetail = data;
        this.stationdetail['noOfConnectors'] = this.stationdetail.connectors[0].totalConnectors;
        this.stationdetail['portTypes'] = this.stationdetail.connectors[0].connectors.map(res => res.portType);
        this.connectors = this.stationdetail.connectors[0].connectors;
        this.basicAuthEnabled = this.stationdetail.basicAuthEnabled;
      },
      error => {
      }
    );
  }

  setSelectedCard(tileName, index) {
    this.selectedIndex = index;
  }

  setSelectedDetailsCard(tileName, index) {
    this.selectedDetailsIndex = index;
  }

  setFirmwareCard(tileName, index) {
    this.firmwareIndex = index;
  }

  setLocalList(tileName, index) {
    this.localListIndex = index;
  }

  setReservationList(tileName, index) {
    this.reservationListIndex = index;
  }

  setTriggerList(tileName, index) {
    this.triggerListIndex = index;
  }

  setChargingListList(tileName, index) {
    this.chargingListIndex = index;
  }

  // getCofigurationKeyList(){
  //   this.chargeBoxService.getConfigurationList(this.stationId).subscribe((res:any)=>{
  //   this.configurationKeyTypeKeys = res.key
  //   })
  // }

  getCofigurationKeyList() {
    this.chargeBoxService.getConfigurationList(this.stationId).subscribe((res: any) => {
        if (res) {
            this.configurationKeyTypeKeys = res.map((item: any) => item.key);
        } else {
            this.configurationKeyTypeKeys = [];
        }
    });
}

}
